import React, { useState, useLayoutEffect } from 'react';

import Switcher from '../Switcher';

export type Theme = 'light' | 'dark';

interface IThemeSwitcher {
  switchTheme: (theme: Theme) => void;
}

export const ThemeSwitcher = ({ switchTheme }: IThemeSwitcher): JSX.Element => {
  const [isDarkTheme, setIsDarkTheme] = useState(
    localStorage.getItem('crm-theme') === 'dark'
  );

  useLayoutEffect(() => {
    switchTheme((localStorage.getItem('crm-theme') as Theme) || 'light');
  }, []);

  const handleTheme = () => {
    setIsDarkTheme(prev => {
      localStorage.setItem('crm-theme', !prev ? 'dark' : 'light');
      switchTheme(!prev ? 'dark' : 'light');
      return !prev;
    });
  };

  return <Switcher onSwitch={handleTheme} isChecked={isDarkTheme} />;
};
